module.exports = __webpack_public_path__ + "media/bootstrap-icons/volume-off-00f123d6.svg";